import { useContext } from 'react'

import {
  Box,
  Button,
  ModalContext,
  SidebarModal,
  Text,
} from '@domain-group/suit-theme'

import Comments from './components/Comments'

import useAdCopyReviewRequestsModal from './hooks/useAdCopyReviewRequestsModal'

const MODAL_KEY = 'AdCopyReviewRequestsModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const AdCopyReviewRequestsModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData?.[MODAL_KEY] ?? {}
  const {
    adCopy, campaignId,
  } = modalPayload

  const adCopyReviewRequestsModalPayload = useAdCopyReviewRequestsModal({
    adCopyId: adCopy.id,
    campaignId,
    orderItemId: adCopy.order_item_id,
  })
  const {
    campaign,
    descendingFilteredComments,
    hasFilteredComments,
    latestCommentDate,
    orderItem,
    service,
  } = adCopyReviewRequestsModalPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Copy Review" titleSecondLine="Requests" />

      <Box flexDirection="column" padding="large" borderBottom="1px solid" borderColor="lineColor">
        <Text color="bodyFontLightColor" fontSize="xsmall" fontWeight="400" lineHeight="16px">{campaign?.title}</Text>

        <Text
          color="bodyFontColor"
          fontSize="medium"
          lineHeight="24px"
          marginTop="medium"
          variant="ellipsis"
        >
          {orderItem?.title}
        </Text>

        <Text color="bodyFontLightColor" fontSize="small" lineHeight="20px">{service?.title}</Text>
      </Box>

      <SidebarModal.Content>
        <Comments
          comments={descendingFilteredComments}
          hasFilteredComments={hasFilteredComments}
          // @ts-expect-error TS2322
          latestCommentDate={latestCommentDate}
        />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => closeModal()}
          size="large"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <AdCopyReviewRequestsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
